import { render, staticRenderFns } from "./consulting.vue?vue&type=template&id=0ac4b1d2&scoped=true&"
import script from "./consulting.vue?vue&type=script&lang=js&"
export * from "./consulting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac4b1d2",
  null
  
)

export default component.exports